import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core'
import { LoggerFactory } from '@elderbyte/ts-logger'
import { BehaviorSubject, Observable } from 'rxjs'
import { ProcessingTimeSpec } from '../processing-time-spec'
import { Property, PropertyType } from '../../../../properties/property'
import { IdValidator } from '../../../../../features/validators/id-validator'
import { ElderTranslatePipe } from '@elderbyte/ngx-starter'
import { PropertyBrowserComponent } from '../../../../properties/property-browser/property-browser.component'
import { PropertySelectDirective } from '../../../../properties/property-select/property-select.directive'
import { MatInput } from '@angular/material/input'
import { MatFormField, MatLabel } from '@angular/material/form-field'
import { FormsModule } from '@angular/forms'
import { MatIcon } from '@angular/material/icon'
import { MatIconButton } from '@angular/material/button'
import {
  ElderHeaderComponent,
  ElderSelectComponent,
  ElderSelectValueDirective,
  ElderThemeDirective,
  ElderUnitSelectDirective,
  SelectionModelPopupDirective,
} from '@elderbyte/ngx-starter'
import { MatToolbar } from '@angular/material/toolbar'
import { AsyncPipe } from '@angular/common'

@Component({
  selector: 'app-processing-time-spec-detail',
  templateUrl: './processing-time-spec-detail.component.html',
  styleUrls: ['./processing-time-spec-detail.component.scss'],
  imports: [
    MatToolbar,
    ElderThemeDirective,
    MatIconButton,
    MatIcon,
    ElderHeaderComponent,
    FormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    ElderSelectComponent,
    PropertySelectDirective,
    ElderSelectValueDirective,
    SelectionModelPopupDirective,
    PropertyBrowserComponent,
    ElderUnitSelectDirective,
    AsyncPipe,
    ElderTranslatePipe,
  ],
})
export class ProcessingTimeSpecDetailComponent implements OnInit {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly log = LoggerFactory.getLogger(this.constructor.name)

  private readonly _pTimeSpec$: BehaviorSubject<ProcessingTimeSpec> = new BehaviorSubject(null)

  private _creationMode: boolean

  @Input()
  public embedded = false

  @Output()
  public close: EventEmitter<Event> = new EventEmitter<Event>()

  @Output()
  public save: EventEmitter<Event> = new EventEmitter<Event>()

  public PropertyType = PropertyType

  public readonly idValidatorPattern = IdValidator.pattern

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {}

  /***************************************************************************
   *                                                                         *
   * Life Cycle                                                              *
   *                                                                         *
   **************************************************************************/

  public ngOnInit(): void {
    if (!this.pTimeSpec) {
      this.initNew()
    }
  }

  /***************************************************************************
   *                                                                         *
   * Getter / Setters                                                        *
   *                                                                         *
   **************************************************************************/

  public get pTimeSpec$(): Observable<ProcessingTimeSpec> {
    return this._pTimeSpec$.asObservable()
  }

  public get pTimeSpec(): ProcessingTimeSpec {
    return this._pTimeSpec$.getValue()
  }

  @Input()
  public set pTimeSpec(spec: ProcessingTimeSpec) {
    if (spec) {
      this._creationMode = !spec.property
      this._pTimeSpec$.next(spec)
    }
  }

  public get creationMode(): boolean {
    return this._creationMode
  }

  public get deletionEnabled(): boolean {
    return !this.creationMode
  }

  /***************************************************************************
   *                                                                         *
   * Component Events                                                        *
   *                                                                         *
   **************************************************************************/

  public onSave(event: Event): void {
    this.emitSave(event)
  }

  public onClose(event: Event): void {
    this.emitClose(event)
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public productPropertySelectionChanged(productProperty: Property): void {
    if (productProperty) {
      this.pTimeSpec.propertyId = productProperty.id
      this.pTimeSpec.unit = productProperty.unit
    }
  }

  /***************************************************************************
   *                                                                         *
   * Private Methods                                                         *
   *                                                                         *
   **************************************************************************/

  private emitSave(event?: Event): void {
    this.save.emit(event)
  }

  private emitClose(event?: Event): void {
    this.close.emit(event)
  }

  private initNew(): ProcessingTimeSpec {
    return new ProcessingTimeSpec()
  }
}
